import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import TrustScoreDetail from './TrustScoreDetail';

// 2026-05-10 — sidebar mini trust badge (자기 회사 매너온도/티어)
// Kyle 의도: AUTODEX 어플에서 업체가 자기 매너온도/티어 보고 다른 업체와 비교
// 클릭 → TrustScoreDetail 모달 (재사용)
function OwnTrustBadge(props){
  var userId=props.userId;
  var[trust,setTrust]=useState(null);
  var[showDetail,setShowDetail]=useState(false);

  useEffect(function(){
    if(!userId)return;
    authFetch(API+'/auctions/users/'+userId+'/trust-score')
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data)setTrust(d.data);
      })
      .catch(function(){/* silent — sidebar mini 라 fail 시 미노출 */});
  },[userId]);

  if(!trust)return null;

  // mysql DECIMAL → string 반환 대응 (Number() 강제, sqlite 모드도 호환)
  var tempNum=Number(trust.trustTemperature!=null?trust.trustTemperature:36.5);
  var temp=tempNum.toFixed(1);
  var tone=tempNum>=36.5?'#059669':tempNum>=35.0?'#D97706':'#DC2626';
  var bg=tempNum>=36.5?'rgba(5,150,105,0.15)':tempNum>=35.0?'rgba(217,119,6,0.15)':'rgba(220,38,38,0.15)';
  var badgeIcon=trust.trustBadge&&trust.trustBadge.icon;

  return (
    <React.Fragment>
      <button onClick={function(e){e.stopPropagation();setShowDetail(true)}}
        title="내 신뢰도 상세"
        style={{
          marginTop:6,padding:'5px 8px',
          background:bg,border:'1px solid '+tone+'40',borderRadius:6,
          display:'flex',alignItems:'center',gap:6,
          cursor:'pointer',width:'100%',
          color:tone,fontSize:11,fontWeight:700,
          fontFamily:'inherit',
        }}>
        {badgeIcon&&<span style={{fontSize:13}}>{badgeIcon}</span>}
        <span style={{flex:1,textAlign:'left'}}>{(trust.trustLevel||'newbie').toUpperCase()}</span>
        <span style={{fontVariantNumeric:'tabular-nums'}}>{temp}°</span>
      </button>
      {showDetail&&<TrustScoreDetail userId={userId} onClose={function(){setShowDetail(false)}}/>}
    </React.Fragment>
  );
}

export default OwnTrustBadge;
